export default "<app-slide [slide]=\"selectedSlide\"></app-slide>\n<div class=\"row justify-content-center mt-5\"></div>\n"